import { gql } from '@apollo/client';

const Mutation = gql`
  mutation CreateExportTemplate(
      $columns: [String]
      $exportType: String!
      $name: String!
      $organizationId: Int!
    ) {
      createExportTemplate(
        columns: $columns
        exportType: $exportType
        name: $name
        organizationId: $organizationId
      ) {
        id
      }
    }
`;

export default Mutation
